import type { FC } from 'react';
import { SdkLoaderWithFallbackScript } from 'src/components/Script/SdkLoaderWithFallbackScript';

export interface TikTokHashedData {
  sha256_email?: string;
  sha256_phone_number?: string;
}

export enum TikTokCheckoutData {
  currency = 'USD',
}

export interface TikTokTrackEventProperties {
  event_id?: string;
  content_type: 'product';
  content_id: 'fresh_food';
  value?: string;
  currency?: TikTokCheckoutData.currency;
}

export interface TikTokTracker {
  page: () => void;
  track: (event: string, properties: TikTokTrackEventProperties) => void;
  identify: (data?: TikTokHashedData) => void;
}

export const TIKTOK_PIXEL_ID = 'C0DEUO9F9F46QGH8G00G';

const fallbackScript = `!function (w, d, t) { w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};}(window, document, 'ttq')`;

const sdkLoader = `!function(){ttq.load('${TIKTOK_PIXEL_ID}');}();`;

export const TikTokScript: FC = () => {
  return (
    <SdkLoaderWithFallbackScript
      sdkLoader={sdkLoader}
      fallbackScript={fallbackScript}
    />
  );
};
